module.exports = __webpack_public_path__ + "img/portrait-103.6db9ae11.jpg";